import { MapConfig } from "./map-interact";

export const mymap_config: MapConfig = {
    "default": {
        "bordercolor": "#9CA8B6", //inter-state borders
        "lakescolor": "#66CCFF", //lakes color
        "shadowcolor": "#000000", //shadow color below the map
        "shadowOpacity": 50, //shadow opacity, value, 0-100
        "namescolor": "#666666", //color of the abbreviations
        "namesShadowColor": "#666666", //tooltip shadow color
    },
    states: {
        "map_1": {
            "namesId": "AL", //name's ID (Don't change it)
            "name": "ALABAMA", //state name
            "slug": "alabama", //state name
            "upcolor": "#EBECED", //state's color when page loads
            "overcolor": "#99CC00", //state's color when mouse hover
            "downcolor": "#993366", //state's color when mouse clicking
            "enable": true, //true/false to enable/disable this state
        },
        "map_2": {
            "namesId": "AK",
            "name": "ALASKA",
            "slug": "alaska",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_3": {
            "namesId": "AZ",
            "name": "ARIZONA",
            "slug": "arizona",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_4": {
            "namesId": "AR",
            "name": "ARKANSAS",
            "slug": "arkansas",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_5": {
            "namesId": "CA",
            "name": "CALIFORNIA",
            "slug": "california",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_6": {
            "namesId": "CO",
            "name": "COLORADO",
            "slug": "colorado",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_7": {
            "namesId": "CT",
            "name": "CONNECTICUT",
            "slug": "connecticut",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_8": {
            "namesId": "DE",
            "name": "DELAWARE",
            "slug": "delaware",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_9": {
            "namesId": "FL",
            "name": "FLORIDA",
            "slug": "florida",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_10": {
            "namesId": "GA",
            "name": "GEORGIA",
            "slug": "georgia",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_11": {
            "namesId": "HI",
            "name": "HAWAII",
            "slug": "hawaii",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_12": {
            "namesId": "ID",
            "name": "IDAHO",
            "slug": "idaho",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_13": {
            "namesId": "IL",
            "name": "ILLINOIS",
            "slug": "illinois",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_14": {
            "namesId": "IN",
            "name": "INDIANA",
            "slug": "indiana",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_15": {
            "namesId": "IA",
            "name": "IOWA",
            "slug": "iowa",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_16": {
            "namesId": "KS",
            "name": "KANSAS",
            "slug": "kansas",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_17": {
            "namesId": "KY",
            "name": "KENTUCKY",
            "slug": "kentucky",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_18": {
            "namesId": "LA",
            "name": "LOUISIANA",
            "slug": "louisiana",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_19": {
            "namesId": "ME",
            "name": "MAINE",
            "slug": "maine",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_20": {
            "namesId": "MD",
            "name": "MARYLAND",
            "slug": "maryland",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_21": {
            "namesId": "MA",
            "name": "MASSACHUSETTS",
            "slug": "massachusetts",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_22": {
            "namesId": "MI",
            "name": "MICHIGAN",
            "slug": "michigan",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_23": {
            "namesId": "MN",
            "name": "MINNESOTA",
            "slug": "minnesota",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_24": {
            "namesId": "MS",
            "name": "MISSISSIPPI",
            "slug": "mississippi",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_25": {
            "namesId": "MO",
            "name": "MISSOURI",
            "slug": "missouri",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_26": {
            "namesId": "MT",
            "name": "MONTANA",
            "slug": "montana",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_27": {
            "namesId": "NE",
            "name": "NEBRASKA",
            "slug": "nebraska",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_28": {
            "namesId": "NV",
            "name": "NEVADA",
            "slug": "nevada",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_29": {
            "namesId": "NH",
            "name": "NEW HAMPSHIRE",
            "slug": "new-hampshire",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_30": {
            "namesId": "NJ",
            "name": "NEW JERSEY",
            "slug": "new-jersey",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_31": {
            "namesId": "NM",
            "name": "NEW MEXICO",
            "slug": "new-mexico",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_32": {
            "namesId": "NY",
            "name": "NEW YORK",
            "slug": "new-york",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_33": {
            "namesId": "NC",
            "name": "NORTH CAROLINA",
            "upcolor": "#EBECED",
            "slug": "north-carolina",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_34": {
            "namesId": "ND",
            "name": "NORTH DAKOTA",
            "slug": "north-dakota",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_35": {
            "namesId": "OH",
            "name": "OHIO",
            "slug": "ohio",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_36": {
            "namesId": "OK",
            "name": "OKLAHOMA",
            "slug": "oklahoma",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_37": {
            "namesId": "OR",
            "name": "OREGON",
            "slug": "oregon",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_38": {
            "namesId": "PA",
            "name": "PENNSYLVANIA",
            "slug": "pennsylvania",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_39": {
            "namesId": "RI",
            "name": "RHODE ISLAND",
            "slug": "rhode-island",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_40": {
            "namesId": "SC",
            "name": "SOUTH CAROLINA",
            "slug": "south-carolina",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_41": {
            "namesId": "SD",
            "name": "SOUTH DAKOTA",
            "slug": "south-dakota",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_42": {
            "namesId": "TN",
            "name": "TENNESSEE",
            "slug": "tennessee",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_43": {
            "namesId": "TX",
            "name": "TEXAS",
            "slug": "texas",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_44": {
            "namesId": "UT",
            "name": "UTAH",
            "slug": "utah",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_45": {
            "namesId": "VT",
            "name": "VERMONT",
            "slug": "vermont",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_46": {
            "namesId": "VA",
            "name": "VIRGINIA",
            "slug": "virginia",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_47": {
            "namesId": "WA",
            "name": "WASHINGTON",
            "slug": "washington",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_48": {
            "namesId": "WV",
            "name": "WEST VIRGINIA",
            "slug": "west-virginia",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_49": {
            "namesId": "WI",
            "name": "WISCONSIN",
            "slug": "wisconsin",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_50": {
            "namesId": "WY",
            "name": "WYOMING",
            "slug": "wyoming",
            "upcolor": "#EBECED",
            "overcolor": "#99CC00",
            "downcolor": "#993366",
            "enable": true,
        },
        "map_51": {
            "namesId": "DC",
            "name": "WASHINGTON DC",
            "slug": "washingtondc",
            "upcolor": "#FF6600",
            "overcolor": "#0000FF",
            "downcolor": "#993366",
            "enable": true,
        },
    },
};
